import { observer } from 'mobx-react';
import * as React from 'react';

export const Accommodation = observer((props: {}) => (
  <div className="cover bg-left bg-center-l a vh-100">
    <div className="center">
      <div className="cf">
        <div className="fl w-100">
          <p className="tc pv2 fw5 f2 bg_orange white">Accomodation</p>
        </div>
        <div className="fl w-100 pa2 pl5">
          <h1 className="f1 b tc">Under Construction!!!</h1>
        </div>
      </div>
    </div>
  </div>
));


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/apps/BCOMS/pages/Accommodation.tsx